import React, { useEffect, useState } from "react"

import axios from "axios"
import { Loader } from "react-feather"
import Employee from "./Employee"

const BookingEmployeeField = ({ field, methods, className }) => {
  const [employees, setEmployees] = useState(null)

  useEffect(() => {
    const getEmployees = async () => {
      //TODO add condition on present calendar id
      try {
        return await axios.get(`/api/employees`)
      } catch (e) {
        console.log(e)
      }
    }

    getEmployees()
      .then((res) => {
        setEmployees(res.data)
      })
      .catch((e) => console.log(e))
  }, [])

  if (!employees) {
    return (
      <div className="mx-auto w-fit">
        <Loader className="mx-auto h-8 w-8 motion-safe:animate-spin" />
        <span>Lade Daten..</span>
      </div>
    )
  }

  return (
    <>
      {employees.length > 0 ? (
        employees.map((employee) => (
          <Employee
            key={employee.id}
            field={field}
            methods={methods}
            employee={employee}
          />
        ))
      ) : (
        <div className="text-center">
          Aktuell sind leider keine Termine verfügbar.
          <br />
          Versuchen Sie es zu einem anderen Zeitpunkt erneut, oder schreiben Sie
          eine E-Mail an{" "}
          <a
            className="underline underline-offset-2"
            href="mailto:anfrage@planmaschine.de"
          >
            anfrage@planmaschine.de
          </a>
        </div>
      )}
    </>
  )
}

export default BookingEmployeeField
